interface GxRedRejectButtonProp {
  onClick: () => void;
  children?: string;
  disabled?: boolean;
}

const GxRedRejectButton = ({ onClick, children }: GxRedRejectButtonProp) => {
  return (
    <button
      onClick={onClick}
      className="gx-dialog-button-red gx-submit-for-approval gx-h4-b"
    >
      <span className="gx-h4-b">{children || ""}</span>
    </button>
  );
};

export default GxRedRejectButton;
